function SumTableArea(props: any) {
  let myProps = {
    countInfo: {},
    openWriteMultyPopup: () => { },
    goDelete: () => { },
    go_excel_down_list: () => { },
    ...props
  };
  let countInfo = myProps.countInfo;

  return (
    <div className="text-center mt-1">
      <div className="list-table-div mt-1" >
        <table style={{ width: "auto", margin: "0 auto" }}>
          <tbody>
            <tr>
              <th>수입</th>
              <td>
                <div style={{ color: "blue", minWidth: 100 }}>{countInfo.row_view_money_in}</div>
              </td>
              <th>지출</th>
              <td>
                <div style={{ color: "red", minWidth: 100 }}>{countInfo.row_view_money_out}</div>
              </td>
              <th>합계</th>
              <td>
                <div style={{ color: "green", fontWeight: "bold", minWidth: 100 }}>{countInfo.in_out_total}</div>
              </td>
              <td style={{ border: 0 }}>
                <button className="btn btn-gray ml-1"
                  onClick={() => { myProps.go_excel_down_list(); }}>
                  엑셀다운
                </button>
                <button className="btn btn-blue ml-1"
                  onClick={() => {
                    myProps.openWriteMultyPopup();
                  }}>등록</button>
                <button className="btn btn-red ml-1"
                  onClick={() => {
                    myProps.goDelete();
                  }}>삭제</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};
export default SumTableArea;